export default __webpack_public_path__ + "static/media/filtersClose.80a06a07.svg";